import React from 'react'

import Icon, { Props } from './Icon'

const IconChevron: React.FC<Props> = (props) => {
  return (
    <Icon title="" viewBox="0 0 35.7 23.7" {...props}>
      <path d="M17.8 22L2.7 6.8l5-5 10.1 10.1L28 1.8l5 5z" />
    </Icon>
  )
}

export default IconChevron
